export default __webpack_public_path__ + "static/cashback-3597490f12260e7f175da329f677de04.gif";